/** @format */

import { observable, action } from 'mobx';

class SidebarStore {
  @observable sidebar = {
    disabled: false,
    open: false,
    activeItem: 'overview',
    subMenuActiveItem: 'operator',
    sidebarItems: [
      {
        name: 'overview',
        icon: 'home',
        link: '/',
        text: 'Panoramica',
        user: 'operator',
      },
      {
        name: 'requests',
        icon: 'list ul',
        link: '/requests',
        text: 'Richieste',
        user: 'operator',
      },
      {
        name: 'clients',
        icon: 'id card',
        link: '/clients',
        text: 'Clienti',
        user: 'operator',
      },
      {
        name: 'sales',
        icon: 'dollar sign',
        link: '/sales',
        text: 'Vendite',
        user: 'operator',
      },
      {
        name: 'dashboard',
        icon: 'chart pie',
        link: '/admin-dashboard',
        text: 'Dashboard',
        user: 'admin',
      },
      {
        name: 'users',
        icon: 'user',
        link: '/admin-users',
        text: 'Utenti',
        user: 'admin',
        disabled: true,
      },
      {
        name: 'warehouses',
        icon: 'warehouse',
        link: '/admin-warehouses',
        text: 'Magazzini',
        user: 'admin',
        disabled: true,
      },
      {
        name: 'cars',
        icon: 'car',
        link: '/admin-cars',
        text: 'Automobili',
        user: 'admin',
        disabled: true,
      },
      {
        name: 'adminParts',
        icon: 'cog',
        link: '/admin-parts',
        text: 'Ricambi',
        user: 'admin',
      },
      {
        name: 'inboundCars',
        icon: 'car',
        link: '/inbound-cars',
        text: 'Nuove auto',
        user: 'operator',
      },
    ],
  };

  @action toggleSidebar() {
    this.sidebar.open = !this.sidebar.open;
  }

  @action disableSidebar() {
    this.sidebar.disable = true;
  }

  @action activeSidebar() {
    this.sidebar.disable = false;
  }

  @action activeItem(name) {
    this.sidebar.activeItem = name;
  }

  @action setActiveSubMenu(subMenu) {
    this.sidebar.subMenuActiveItem = subMenu;
  }
}

const store = new SidebarStore();

export default store;
